export const getStorageKey = (key) => {
  try {
    return localStorage.getItem(key)
  } catch (error) {
    console.log('Error getting storage key', key, error);
    return null
  }
}

export const setStorageKey = (key, value) => {
  try {
    localStorage.setItem(key, value)
  } catch (error) {
    console.log('Error setting storage key', key, error);
  }
}

export const removeStorageKey = (key) => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.log('Error removing storage key', key, error);
  }
}

/**
 * Settings that describe THIS COMPUTER rather than the person signed in, so a
 * log out keeps them. The WhatsApp choice is whether the desktop app is
 * installed here (Alex, 2026-10-23: "remember the toggle selection"); wiping
 * it on every log out made the Trade Feed forget it. Nothing private belongs
 * in this list: everything else, tokens and cached data included, is cleared.
 */
export const DEVICE_PREFERENCE_KEYS = ['rc.tradeFeed.whatsappTarget'];

export const clearStorage = () => {
  try {
    const kept = DEVICE_PREFERENCE_KEYS
      .map((key) => [key, localStorage.getItem(key)])
      .filter(([, value]) => value !== null);
    localStorage.clear()
    kept.forEach(([key, value]) => localStorage.setItem(key, value));
  } catch (error) {
    console.log('Error clearing storage', error);
  }
}
